import { Link as NextLink } from '@nextui-org/react';
import styled from 'styled-components';

const Link = styled(NextLink).attrs(({ css }) => ({
  css: {
    '&': {
      fontFamily: '$dmSans',
      fontSize: '$md',
      lineHeight: '$s',
      ...(css?.['&'] ?? {}),
    },
    ...(css ?? {}),
  },
}))``;

export default Link;
